'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkinDataRequested = checkinDataRequested;
exports.checkinDataReceived = checkinDataReceived;
exports.checkinDataRequestFailed = checkinDataRequestFailed;
var CHECKIN_DATA_REQUESTED = exports.CHECKIN_DATA_REQUESTED = 'CHECKIN_DATA_REQUESTED';

function checkinDataRequested() {
    return {
        type: CHECKIN_DATA_REQUESTED
    };
}

var CHECKIN_DATA_RECEIVED = exports.CHECKIN_DATA_RECEIVED = 'CHECKIN_DATA_RECEIVED';

function checkinDataReceived(checkinData) {
    return {
        type: CHECKIN_DATA_RECEIVED,
        checkinData: checkinData
    };
}

var CHECKIN_DATA_REQUEST_FAILED = exports.CHECKIN_DATA_REQUEST_FAILED = 'CHECKIN_DATA_REQUEST_FAILED';

function checkinDataRequestFailed(error) {
    return {
        type: CHECKIN_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/checkinDataActions.js
// module id = 201
// module chunks = 0